<template>
  <div class="symbol-editor">
    <div class="symbol-editor__row">
      <label>Color</label>
      <input type="color" :value="colorHex" @input="setColorHex($event.target.value)">
      <input type="number" min="0" max="100" :value="colorOpacity" @input="setColorOpacity($event.target.value)">
      <span class="symbol-editor__unit">% opacidad</span>
    </div>

    <div class="symbol-editor__row">
      <label>Ancho</label>
      <input type="number" min="0.5" max="20" step="0.5" :value="symbol.width" @input="update({ width: Number($event.target.value) })">
      <span class="symbol-editor__unit">pt</span>
    </div>

    <div class="symbol-editor__row">
      <label>Patrón</label>
      <select :value="styleValue" @change="update({ style: $event.target.value })">
        <option v-for="option in LINE_STYLES" :key="option.value" :value="option.value">{{ option.label }}</option>
      </select>
    </div>
  </div>
</template>

<script>
import { rgbToHex, hexToRgb } from "@/services/layers/symbology";

//Las opciones replican los patrones que `symbology.js` sabe traducir a OL.
//`esriSLSNull` queda fuera a propósito: quien quiera ocultar la capa la apaga.
const LINE_STYLES = [
  { value: "esriSLSSolid", label: "Sólida" },
  { value: "esriSLSDash", label: "Guiones" },
  { value: "esriSLSDot", label: "Puntos" },
  { value: "esriSLSDashDot", label: "Guión-punto" },
  { value: "esriSLSDashDotDot", label: "Guión-punto-punto" },
];

export default {
  name: "SymbologyLineEditor",
  props: {
    symbol: { type: Object, required: true },
  },
  data() {
    return { LINE_STYLES };
  },
  computed: {
    colorHex() {
      return rgbToHex(this.symbol.color);
    },
    colorOpacity() {
      const color = this.symbol.color;
      const alpha = Array.isArray(color) && color.length > 3 ? color[3] : 255;
      return Math.round((alpha / 255) * 100);
    },
    //La semilla del servicio o una simbología vieja pueden traer un style fuera
    //de la lista (`esriSLSNull`, por ejemplo): el <select> no lo encontraría, el
    //navegador mostraría "Sólida" y Guardar escribiría una línea invisible.
    styleValue() {
      return LINE_STYLES.some(option => option.value === this.symbol.style) ? this.symbol.style : "esriSLSSolid";
    },
  },
  methods: {
    update(patch) {
      this.$emit("input", Object.assign({}, this.symbol, patch));
    },
    setColorHex(hex) {
      const alpha = Array.isArray(this.symbol.color) && this.symbol.color.length > 3 ? this.symbol.color[3] : 255;
      this.update({ color: hexToRgb(hex).concat(alpha) });
    },
    setColorOpacity(percent) {
      const alpha = Math.round((Math.max(0, Math.min(100, Number(percent) || 0)) / 100) * 255);
      this.update({ color: hexToRgb(this.colorHex).concat(alpha) });
    },
  },
};
</script>

<style lang="scss" scoped>
.symbol-editor__row {
  display: flex;
  align-items: center;
  gap: 0.5rem;
  margin-bottom: 0.4rem;

  label {
    min-width: 8rem;
    margin: 0;
  }

  input[type="number"] {
    width: 5rem;
  }

  input[type="color"] {
    width: 3rem;
    padding: 0;
  }
}

.symbol-editor__unit {
  color: var(--color-ghost);
  font-size: 0.82rem;
}
</style>
